import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { useEffect } from "react";

import { redirect } from "./constants/helpers";

import Aos from "aos";
import "aos/dist/aos.css";

import HomeScreen from "./screen/HomeScreen";
import VolunteerApplicationScreen from "./screen/VolunteerApplicationScreen";
import NotFound from "./screen/NotFound";

document.addEventListener("DOMContentLoaded", () => {
  Aos.init();
});

const App = () => {
  useEffect(() => {
    redirect();
  });

  return (
    <>
      <Router>
        <Routes>
          <Route
            path="/volunteer-application"
            element={<VolunteerApplicationScreen />}
          />
          <Route path="/" element={<HomeScreen />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </>
  );
};

export default App;
